// import saga helper
import { call, put, all, takeEvery } from "redux-saga/effects";

import { GET_PAYMENT_METHOD_LIST } from "./actionType";
import {
  getPaymentMethodListSuccess,
  getPaymentMethodListFailure,
} from "./action";

import { getPaymentMethodListApiCall } from "../../helpers/fakebackend_helper";

// Get Payment Method List Saga
function* getPaymentMethodListSaga() {
  try {
    const response = yield call(getPaymentMethodListApiCall);
    yield put(getPaymentMethodListSuccess(response));
  } catch (error) {
    yield put(getPaymentMethodListFailure(error));
  }
}

// Watcher
function* watcherGetPaymentMethodListSaga() {
  yield takeEvery(GET_PAYMENT_METHOD_LIST, getPaymentMethodListSaga);
}

// Export
export default function* PaymentMethod() {
  yield all([watcherGetPaymentMethodListSaga()]);
}
